export default "__VITE_ASSET__BpNqGgHi__"